class CssProps {
    static BACKGROUND_COLOR_PROP = "backgroundColor"
}

export { CssProps }